import { Paper, Text, Stack, Group, Badge, Box } from '@mantine/core'
import { IconShield, IconTrendingUp } from '@tabler/icons-react'

const archetypeEmoji = {
  stabilizer: '🛡️',
  mobilizer: '⚡',
  strategist: '🎯',
  connector: '🔗',
}

export function ArchetypeCard({ archetype, evolved }) {
  if (!archetype) return null

  return (
    <Paper p="lg" className="glass" style={{ borderColor: 'rgba(0, 229, 255, 0.2)', position: 'relative', overflow: 'hidden' }}>
      <Box style={{ position: 'absolute', top: -20, right: -20, fontSize: 80, opacity: 0.04, pointerEvents: 'none' }}>
        {archetypeEmoji[archetype.key] || '🎯'}
      </Box>
      <Stack gap="sm">
        <Group gap="sm">
          <Text size="xl" style={{ lineHeight: 1 }}>{archetypeEmoji[archetype.key] || '🎯'}</Text>
          <Box>
            <Text size="xs" c="dimmed" ff="Rajdhani, sans-serif" fw={600} tt="uppercase" lts={1}>
              {evolved ? 'Evolved Profile' : 'Primary Tendency'}
            </Text>
            <Text size="lg" fw={700} ff="Orbitron, sans-serif" c="cyan.3" className="glow-text-cyan">
              {evolved ? `${archetype.name} → ${archetype.evolvedArchetype}` : archetype.name}
            </Text>
          </Box>
        </Group>
        <Text size="sm" c="gray.4" lh={1.5}>{archetype.description}</Text>
        <Group gap="sm">
          <Badge size="md" variant="light" color="green" leftSection={<IconShield size={12} />}>
            {archetype.strength}
          </Badge>
          <Badge size="md" variant="light" color="orange" leftSection={<IconTrendingUp size={12} />}>
            {archetype.growth}
          </Badge>
        </Group>
      </Stack>
    </Paper>
  )
}
